import { SVGProps } from 'react';

export const Tag = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.99948 5.59949C3.11468 5.59949 2.39948 4.88188 2.39948 3.99948C2.39948 3.11548 3.11468 2.39948 3.99948 2.39948C4.88268 2.39948 5.59949 3.11548 5.59949 3.99948C5.59949 4.88188 4.88268 5.59949 3.99948 5.59949M15.7657 9.03443L6.96562 0.234401C6.81522 0.0840003 6.61202 0 6.40002 0H0.800003C0.358401 0 0 0.358401 0 0.800003V6.40002C0 6.61202 0.0848003 6.81602 0.234401 6.96562L9.03443 15.7657C9.19043 15.9217 9.39523 16.0001 9.60003 16.0001C9.80483 16.0001 10.0096 15.9217 10.1656 15.7657L15.7657 10.1656C16.0785 9.85283 16.0785 9.34723 15.7657 9.03443Z"
      fill="currentColor"
    />
  </svg>
);
